<template>
  <div id="goodsArea">
    <div class="top">
        <div class="mobileTop"></div>
        <div class="topPart">
          <span class="backToApp" @click="back()"></span>{{title}}<i class="share"></i>
        </div>
    </div>
    <div class="part">
      <div class="box">
        <img class="cover" :src='backImg'>
        <div :class="['pointArea',reciveKey]" v-show="reciveKey == 'house'">
           <div :class="['point', 'one',nowClick == 0?'active':'']" @click="showList(0)"></div>
           <div :class="['point', 'two',nowClick == 1?'active':'']" @click="showList(1)"></div>
           <div :class="['point', 'three',nowClick == 2?'active':'']" @click="showList(2)"></div>
           <div :class="['point', 'four',nowClick == 3?'active':'']" @click="showList(3)"></div>
           <div :class="['point', 'five',nowClick == 4?'active':'']" @click="showList(4)"></div>
           <div :class="['point', 'six',nowClick == 5?'active':'']" @click="showList(5)"></div>
           <div :class="['point', 'seven',nowClick == 6?'active':'']" @click="showList(6)"></div>
           <div :class="['point', 'eight',nowClick == 7?'active':'']" @click="showList(7)"></div>
        </div>
        <div :class="['pointArea',reciveKey]" v-show="reciveKey == 'outdoor'">
           <div :class="['point', 'one',nowClick == 0?'active':'']" @click="showList(0)"></div>
           <div :class="['point', 'two',nowClick == 1?'active':'']" @click="showList(1)"></div>
           <div :class="['point', 'three',nowClick == 2?'active':'']" @click="showList(2)"></div>
           <div :class="['point', 'four',nowClick == 3?'active':'']" @click="showList(3)"></div>
           <div :class="['point', 'five',nowClick == 4?'active':'']" @click="showList(4)"></div>
           <div :class="['point', 'six',nowClick == 5?'active':'']" @click="showList(5)"></div>
           <div :class="['point', 'seven',nowClick == 6?'active':'']" @click="showList(6)"></div>
           <div :class="['point', 'eight',nowClick == 7?'active':'']" @click="showList(7)"></div>
        </div>
      </div>
      <div class="bottomBtn">
        <div class="slide">
          <span class="btn" @click="showList(index)" v-for="(item,index) in BtnList" :key="item.id" :id="index">{{ item }}</span>
        </div>

      </div>
    </div>
    <div class="mask" v-show="maskshow"></div>
    <div class="maskInner"  v-show="maskshow">
      <p class="close" @click="maskshow = !maskshow">x</p>
      <ul class="tab">
        <li :class="['name', nowIndex == index?'active':'']" @click="switchTab(index)" v-for="(item,index) in BtnList" :key="item.id">{{ item }}</li>
      </ul>
      <div class="goodsList">
        <div class="box" v-for="item in goodsList" :key="item.id" @click="goDetail(item.goods_id,item.business_id)">
           <div class="leftBox">
            <img :src="item.cover" alt="">
           </div>
           <div class="rightBox">
            <p class="name">{{ item.goodsName }}</p>
            <p class="price">￥<span class="dot">{{ item.price }}</span></p>
           </div>
        </div>
        <div class="bottom">
          <span class="serve" @click="goServe()">商品需求</span>
          <span class="achive" @click="serverClick()">联系我们</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import areaGoods from './goods_area.json'
export default {
  data () {
    return {
      nowClick: 0,
      nowIndex: 0,
      title: '',
      reciveKey: '',
      areaGoodsObj: areaGoods,
      backImg: '',
      background: [
        {
          name: 'house',
          src: require('./images/jia.jpg')
        },
        {
          name: 'outdoor',
          src: require('./images/chu.jpg')
        },
        {
          name: 'child',
          src: require('./images/er.jpg')
        },
        {
          name: 'company',
          src: require('./images/qi.jpg')
        },
        {
          name: 'factory',
          src: require('./images/cang.jpg')
        },
        {
          name: 'wear',
          src: require('./images/fang.jpg')
        }
      ],
      BtnList: [],
      goodsList: [],
      maskshow: false
    }
  },
  mounted () {
    this.title = this.$route.query.name
    this.reciveKey = this.$route.query.id
    this.handleBackGround()
    this.contType()
  },
  methods: {
    back () {
      this.$router.go(-1)
    },
    serverClick () {
      this.YSF.init('1a5d46871ba2e8c628b5a7abe265ef26', {
        templateId: 123, // templateId表示自定义会话邀请的模板标识
        shuntId: 123, // shuntId表示访客选择多入口分流模版id
        sessionInvite: false, // sessionInvite表示是否开启会话邀请设置
        hidden: 1 // hidden表示是否隐藏访客端默认入口
      }).then(ysf => {
        ysf('open')
        // ysf('product', {
        //     show: 1,
        //     title: '任天堂（Nintendo）Switch游戏机',
        //     desc: '任天堂（Nintendo） Switch NS NX掌上游戏机便携 塞尔达马里奥新款游戏机 主机不锁 日版黑机彩色手柄+中文赛/塞尔达传说(指南+地图)',
        //     picture: 'https://img10.360buyimg.com/n5/s75x75_jfs/t4030/290/29851193/293745/d5e2b731/58ac3506Nbb57b5f6.jpg',
        //     note: '￥1978',
        //     url: 'https://www.taobao.com/',
        //     sendByUser: 0
        // })
      }).catch(error => {
        console.log(error)
        console.log('sdk加载失败')
      })
    },
    goServe () {
      this.$router.push({
        path: '/goodsMy'
      })
    },
    showList (flag) {
      let ele = document.getElementById(flag)
      ele.scrollIntoView()
      this.maskshow = true
      this.nowIndex = flag
      this.nowClick = flag

      this.contType()
    },
    goDetail (gid, bid) {
      this.$router.push({
        path: '/myGoods',
        query: {
          goodsId: gid,
          businessId: bid
        }
      })
    },
    handleArrayClassification (data, label) {
      const labelsMap = {} // map存储
      data.forEach((item) => {
        if (!labelsMap[item[label]]) { // 没有就创建
          labelsMap[item[label]] = {
            children: []
          }
        }
        labelsMap[item[label]].children.push(item)
      })
      return labelsMap
    },
    switchTab (flag) {
      this.nowIndex = flag
      this.nowClick = flag
      this.contType()
    },
    contType () {
      let AimArr = this.areaGoodsObj[this.reciveKey]
      let Arr = []
      let obj = {}
      let str = ''
      obj = this.handleArrayClassification(AimArr, 'type')
      AimArr.forEach((item, index) => {
        Arr.push(item.type)
      })
      console.log(obj)
      this.BtnList = [...new Set(Arr)]
      str = this.BtnList[this.nowIndex]
      this.goodsList = obj[str].children
    },
    handleBackGround () {
      this.background.forEach((item, index) => {
        if (this.reciveKey == item.name) {
          this.backImg = item.src
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
#goodsArea{
  display: inline-block;
  font-size: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  .top{
    background: #ffffff;
    width: 100%;
    .mobileTop{
      height: 27px;
    }
    .topPart{
      display: inline-block;
      width: 100%;
      height: 40px;
      line-height: 40px;
      position: relative;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #1D2129;
      text-align: center;
      .backToApp{
        display: inline-block;
        position: absolute;
        left: 15px;
        top: 5px;
        width: 30px;
        height: 30px;
        line-height: 30px;
        &::before{
          content: '';
          position: absolute;
          left: 0;
          top: calc(50% - 6px);
          right: 0;
          margin: 0 auto;
          width: 12px;
          height: 12px;
          border-top: 2px solid #1D2129;
          border-left: 2px solid #1D2129;
          transform: rotate(-45deg);
        }
      }
      .share{
          position: absolute;
          right:20px;
          width: 16px;
          height: 16px;
          top: 12px;
          background: url('./images/share.svg')no-repeat center center;
          background-size: cover;
      }
    }
  }
  .part{
    position: relative;
    display: inline-block;
    width: 100%;
    height: 100%;
    overflow: auto;
    .box{
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
      .cover{
        display: inline-block;
        width: 1080px;
        height: 812px;
        z-index: 1;
      }
      .pointArea{
        position: absolute;
        top: 0;
        left: 0;
        width: 1080px;
        height: 812px;
        z-index: 10;
        .point{
        position: absolute;
        width: 60px;
        height: 60px;
        background: #FFFEFF;
        background-size: cover;
        background-repeat: no-repeat;
        box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.58);
        opacity: 0.8;
        border-radius: 50%;
        &.active{
          border: 2px solid rgb(40,120,255);
        }
        }
        &.house{
          .point{
            &.one{
              top: 596px;
              left: 509px;
              background-image: url('./images/5kg.png');
            }
            &.two{
              top: 402px;
              left: 326px;
              background-image: url('./images/jymhq.png');
            }
            &.three{
              top: 290px;
              left: 100px;
              background-image: url('./images/mht.png');
            }
            &.four{
              top: 582px;
              left: 788px;
              background-image: url('./images/mhqiu.png');
            }
            &.five{
              top: 596px;
              left: 349px;
              background-image: url('./images/bjq.png');
            }
            &.six{
              top: 71px;
              left: 489px;
              background-image: url('./images/gchjq.png');
            }
            &.seven{
              top: 515px;
              left: 638px;
              background-image: url('./images/zjhxq.png');
            }
            &.eight{
              top: 435px;
              left: 939px;
              background-image: url('./images/xfyjb.png');
            }

          }
        }
        &.outdoor{
          .point{
            &.one{
              top: 513px;
              left: 710px;
              background-image: url('./images/5kg.png');
            }
            &.one{
              top: 125px;
              left: 841px;
              background-image: url('./images/jymhq.png');
            }
          }
        }

      }

    }
    .bottomBtn{
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 110px;
      z-index: 10;
      padding: 20px 15px;
      overflow:hidden;
      .slide{
        width: 100%;
        overflow-x:scroll;
        display: inline-block;
        white-space: nowrap;
        .btn{
          display: inline-block;
          padding: 14px 20px;
          background: #9E918B;
          border-radius: 10px;
          text-align: center;
          font-size: 16px;
          color: #ffffff;
          font-weight: bold;
          line-height: 16px;
          margin-right: 10px;
        }
        &::-webkit-scrollbar{
          display:none;
        }
      }

    &::after{
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 110px;
        background: rgba(29, 33, 41,0.3);
        filter: blur(10px); /*设置背景虚化的程度*/
        -webkit-backdrop-filter: blur(10px);
        backdrop-filter: blur(10px); /*设置背景虚化的程度*/
        z-index: -1;
      }
    }
    &::-webkit-scrollbar{
        display:none;
      }
  }
  .mask{
    position: absolute;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    left: 0;
    top: 0;
    background: rgba($color: #000000, $alpha: 0.5);
    z-index: 10;
  }
  .maskInner{
    position: absolute;
    width: 100vw;
    left: 0;
    bottom: 0;
    background: #ffffff;
    z-index: 20;
    height: 600px;
    .close{
      height: 43px;
      text-align: right;
      font-size: 16px;
      color: #B8B8B8;
      padding-right: 15px;
      line-height: 43px;
    }
    .tab{
      display: flex;
      width: 100vw;
      height: 35px;
      line-height: 35px;
      border-bottom: 1px solid #EEEEEE;
      white-space: nowrap;
      overflow-x: auto;
      // overflow-y: hidden;
      padding-left: 15px;
      padding-right: 15px;
      .name{
        flex:1;
        font-size: 14px;
        color: #0E050A;
        margin-right: 30px;
        &:last-child{
          margin-right: 0;
        }
        &.active{
          font-size: 16px;
          font-weight: bold;
          color:#9E918B;
        }
      }
      &::-webkit-scrollbar{
        display:none;
      }
    }
    .goodsList{
      padding: 15px 13px 90px 13px;
      display: inline-block;
      width: 100%;
      height: calc(100% - 80px);
      overflow-y: scroll;
      .box{
        display: inline-block;
        height: 110px;
        width: 100%;
        margin-bottom: 20px;
        .leftBox{
          display: inline-block;
          width: 109px;
          height: 108px;
          margin-right: 10px;
          img{
            display: inline-block;
            max-width: 109px;
            max-height: 108px;
          }
        }
        .rightBox{
          position: relative;
          display: inline-block;
          width: calc(100% - 120px);
          height: 108px;
          vertical-align: top;
          .name{
            display: inline-block;
            line-height: 24px;
            font-size: 15px;
            color: #0E050A;
            margin-bottom: 40px;
          }
          .price{
            text-align: left;
            font-size: 12px;
            color: #9e918b;
            height: 18px;
            .dot{
              font-size: 18px;
              color: #9e918b;
              line-height: 18px;
              display: inline-block;
              margin-left: 2px;
            }
          }
          &::after{
            content:'';
            position: absolute;
            width: 66px;
            height: 19px;
            background: url('./images/vip.png')no-repeat center center;
            background-size: contain;
            left: 0;
            bottom: 35px;
          }
        }
      }
      &::-webkit-scrollbar{
        display:none;
      }
    }
    .bottom{
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 85px;
      padding: 5px 15px;
      background: #FFFFFF;
      .serve,.achive{
        display: inline-block;
        width: 165px;
        height: 45px;
        background: #9E918B;
        border-radius: 4px;
        margin-right: 10px;
        line-height: 40px;
        font-size: 15px;
        color: #ffffff;
        text-align: center;
      }
      .achive{
        margin-right: 0;
      }
    }
  }
  // <div class="mask"></div>
  //   <div class="maskInner">
  //     <p class="close"></p>
  //     <ul class="tab">
  //       <li class="name" @click="switchTab()" v-for="item in BtnList" :key="item.id">{{ item }}</li>
  //     </ul>
  //     <div class="goodsList">
  //       <div class="box" v-for="item in goodsList" :key="item.id">
  //          <div class="leftBox"></div>
  //          <div class="rightBox">
  //           <p class="name"></p>
  //           <p class="price">￥<span class="dot">{{ item.price }}</span></p>
  //          </div>
  //       </div>
  //       <div class="bottom">
  //         <span class="serve">商品需求</span>
  //         <span class="achive">联系我们</span>
  //       </div>
  //     </div>
  //   </div>
}
</style>



// WEBPACK FOOTER //
// src/view/manman/goodsArea.vue